
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/what-we-buy",
      function () {
        return require("private-next-pages/what-we-buy/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/what-we-buy"])
      });
    }
  